import { Component, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public scroll;
  public stick = false;
  constructor(private renderer: Renderer2) { }

  ngOnInit() {
    this.renderer.listen(window, 'scroll', ($event) => {
       this.scroll = (window.scrollY);
      if(this.scroll < 550){
        this.stick = true;
      }else{
        this.stick = true;
      }

    })
    
  }

}
